import styles from './FieldMessage.module.scss'

interface FieldMessageProps {
  /** Id para asociar por `aria-describedby` desde el control. */
  id: string
  /** Texto de error (tiene prioridad y se anuncia con `role="alert"`). */
  error?: string
  /** Texto de ayuda (se muestra si no hay error). */
  helper?: string
}

/**
 * Mensaje de un campo de formulario: error (con `role="alert"`) o ayuda.
 * Reutilizable por cualquier campo del DS. No renderiza nada si no hay texto.
 */
export function FieldMessage({ id, error, helper }: FieldMessageProps) {
  if (!error && !helper) return null

  return (
    <span id={id} className={error ? styles.error : styles.helper} role={error ? 'alert' : undefined}>
      {error ?? helper}
    </span>
  )
}
